import React, { useState, useEffect, useRef } from "react";
import "../../../home.css";
import defaultStyle from "../../../utils/default";
import ProgressBar from "../progressbar";
import { Howl } from "howler";
import mixpanel from "mixpanel-browser";
import { logContentBlockPressEvent } from "../../../utils/events";
import { useAppContext } from './../../../util'

function AudioPlayer({ audio, title, color, index, contentBlockId }) {
  const { userId, pageId } = useAppContext()
  const isSolid = color?.elements?.style === "Solid"; // Solid true
  const [isPlaying, setIsPlaying] = useState(false);
  const [rawDuration, setRawDuration] = useState(0);
  const [progress, setProgress] = useState(0); // [0, 100]
  const [isMute, setisMute] = useState(false);
  const sound = useRef(null);
  useEffect(() => {
    sound.current = new Howl({
      src: [audio],
      html5: true,
      mute: false,
      onload: () => {
        setRawDuration(sound.current.duration());
      },
      onend: () => {
        setIsPlaying(false);
      },
      onplay: () => {
        if (sound.current.seek() === 0) {
          mixpanel.track(
            "Web Audio Played", 
            {
              distinct_id: userId,
              stack_id: pageId,
            }
          )
        }
      },
    });
  }, [audio]);

  useEffect(() => {
    let interval;
    if (isPlaying) {
      interval = setInterval(() => {
        const currentPosition = sound.current?.seek();
        setProgress(
          Math.floor(parseFloat((currentPosition * 100) / rawDuration))
        );
      }, 0);
    } else {
      clearInterval(interval);
    }

    return () => clearInterval(interval);
  }, [isPlaying, rawDuration]);

  const handleMusic = (e) => {
    e.stopPropagation();
    sound.current.mute(!isMute);
    setisMute(!isMute);
  };

  function formatTime(timeInSeconds) {
    const remainingTime = rawDuration - timeInSeconds;
    const minutes = Math.floor(remainingTime / 60);
    const seconds = Math.floor(remainingTime % 60);
    return `-${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  }

  const borderRadius =
    color?.elements?.shape === "Pill"
      ? "16px"
      : color?.elements?.shape === "Rounded"
      ? "16px"
      : "0px";

  const handleSeek = (newPercentage) => {
    if (sound.current) {
      // Calculate the new position in seconds based on the percentage
      const newPosition = (newPercentage / 100) * rawDuration;

      // Seek to the new position
      sound.current.seek(newPosition);

      // Update the progress
      setProgress(newPercentage);

      // If the audio is paused, play it after seeking
      if (!isPlaying) {
        sound.current.play();
        setIsPlaying(true);
      }
    }
  };

  const handlePlayPause = (e) => {
    e.stopPropagation();

    if (isPlaying) {
      sound?.current?.pause();
    } else {
      sound.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  const handleAudio = () => {
    if (isPlaying) {
      sound?.current?.pause();
    } else {
      sound.current.play();
    }
    setIsPlaying(!isPlaying);
    logContentBlockPressEvent(contentBlockId);
  };


  return (
    <div
      onClick={handleAudio}
      key={index}
      className="audio"
      style={{
        background: isSolid
          ? color?.color?.secondary || defaultStyle.color.secondary
          : "none",
        border: !isSolid
          ? `2px solid ${color?.color?.primary || defaultStyle.color.primary} `
          : "none",
        borderRadius: borderRadius,
      }}
    >
      <p
        className="audio__title"
        style={{ color: color?.color?.primary || defaultStyle.color.primary }}
      >
        {title}
      </p>
      <div className="audio__controller">
        <button
          className="audio__controller__button"
          style={{
            background: color?.color?.primary || defaultStyle.color.primary,
          }}
          onClick={handlePlayPause}
        >
          {isPlaying ? (
            <div
              style={{
                color: color?.color?.secondary || defaultStyle.color.secondary,
              }}
            >
              <i className="fas fa-pause"></i>
            </div>
          ) : (
            <div
              style={{
                color: color?.color?.secondary || defaultStyle.color.secondary,
              }}
            >
              <i className="fas fa-play"></i>
            </div>
          )}
        </button>
        <ProgressBar
          progress={progress}
          color={color?.color?.primary || defaultStyle.color.primary}
          isSolid={isSolid}
          outlinedColor={
            color?.color?.secondary || defaultStyle.color.secondary
          }
          handleSeek={handleSeek} // Pass the handleSeek function
        />
        <p
          className="audio_controler__time"
          style={{ color: color?.color?.primary || defaultStyle.color.primary }}
        >
          {formatTime(sound.current?.seek())}
        </p>
      </div>
    </div>
  );
}

export default AudioPlayer;
